export const PROFILE_CONNECTIONS_REQUESTING = 'PROFILE_CONNECTIONS_REQUESTING'
export const PROFILE_CONNECTIONS_REQUEST_SUCCESS = 'PROFILE_CONNECTIONS_REQUEST_SUCCESS'
export const PROFILE_CONNECTIONS_REQUEST_ERROR = 'PROFILE_CONNECTIONS_REQUEST_ERROR'
